import React from 'react';
import Modal from '@common/modal';
import { NCC_SUPPORT_EMAIL } from '@domain/constant/contact';

import classnames from 'classnames/bind';
import styles from './saveFailModal.module.scss';
const cx = classnames.bind(styles);

interface SaveFailModalProps {
  visible: boolean;
}

const SaveFailModal = ({ visible }: SaveFailModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>결과 저장에 실패했어요.</em>

        <p className={cx('desc')}>
          네트워크 상태를 확인 후 다시 한번 시도해 주세요.
          <br />
          계속해서 오류가 발생할 경우
          <br />
          {NCC_SUPPORT_EMAIL}로 문의해 주세요.
        </p>

        <div className={cx('btnArea')}>
          <button className={cx('btn', 'type1')} type={'submit'}>
            다시 시도
          </button>
          <a className={cx('btn', 'type2')} href={NCC_SUPPORT_EMAIL} target="_blank">
            문의하기
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default SaveFailModal;
